const types = {
    contractTermTypes: [
        {id: '3', name: '3'},
        {id: '6', name: '6'},
        {id: '9', name: '9'},
        {id: '12', name: '12'},
        {id: '18', name: '18'},
        {id: '24', name: '24'}
    ],
    meterTypes: [
        {id: 'single_rate_meter', name: 'meterTypeLabelSingle'},
        {id: 'double_rate_meter', name: 'meterTypeLabelDouble'}
    ],
    powerMeasurementTypes: [
        {id: 'with', name: 'powerTypeLabelWith'},
        {id: 'without', name: 'powerTypeLabelWithout'},
        // {id: 'without_reactive', name: {en :'Without reactive', cg: 'Bez reaktivne'}},
        {id: 'with_reactive', name: 'powerTypeLabelWithReactive'}
    ],
    rateTypes: [
        {id: true, name: 'Confirmed'},
        {id: 'false', name: 'Unconfirmed'}
    ],
    seasonTypes: [
        {id: 'high', name: 'seasonTypeLabelHigh'},
        {id: 'low', name: 'seasonTypeLabelLow'},
        {id: 'no_season', name: 'seasonTypeLabelNoSeason'}
    ]
}

export default types


// WEBPACK FOOTER //
// ./src/model/dropdownTypes.js